export const validateEmail = (email) => {
  const emailRegex = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+){1,3}(\.\w{2,3}){1,2}$/);
  return emailRegex.test(email.trim());
};